var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height",class:['bg-' + _vm.color]},[_c('v-header',{attrs:{"title":_vm.title,"title-color":_vm.titleColor,"icon":_vm.icon}},[_c('template',{slot:"right"},[_vm._t("right")],2)],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87c607c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Column.vue
// module id = AqXi
// module chunks = 44